import { PackingRecommendations, PackingItem } from "@/features/planner/api/planner";

interface PackingListProps {
    data: PackingRecommendations;
}

export const PackingList = ({ data }: PackingListProps) => {
    if (!data) return null;

    const hasEssentials = data.essentials && data.essentials.length > 0;
    const hasClothing = data.clothing && data.clothing.length > 0;
    const hasExtras = data.extras && data.extras.length > 0;

    if (!hasEssentials && !hasClothing && !hasExtras) return null;

    return (
        <div className="mx-5 p-10 bg-white">
            <h2 className="text-center text-[28px] font-bold text-[#187A85] mb-6 font-serif">
                Packing Essentials
            </h2>

            {hasEssentials && (
                <PackingCategory title="Documents & Essentials" items={data.essentials} />
            )}

            {hasClothing && (
                <PackingCategory title="Clothing" items={data.clothing} />
            )}

            {hasExtras && (
                <PackingCategory title="Extras" items={data.extras} />
            )}
        </div>
    );
};

const PackingCategory = ({ title, items }: { title: string; items: PackingItem[] }) => (
    <div className="mb-8 last:mb-0">
        <h3 className="text-[18px] font-bold text-[#E76828] mb-4">{title}</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {items.map((item, index) => (
                <div key={index} className="bg-[#FFF9F5] rounded-xl p-4 flex flex-col justify-center h-full">
                    <div className="text-[15px] font-medium text-[#222222] mb-1 leading-snug">
                        {item.item} {item.quantity && <span className="text-[#6D6D6D] font-normal">({item.quantity})</span>}
                    </div>
                    {item.reason && (
                        <div className="text-[13px] text-[#333333] leading-relaxed">
                            {item.reason}
                        </div>
                    )}
                </div>
            ))}
        </div>
    </div>
);
